import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Drawer from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Drawer';
import { useMessagesContext } from 'Views/Page/Content/Templates/MessagesPage/MessagesContext';
import {
  MessagesPanelContentContainer,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/MessagesPanel/components/MessagesPanelContent/MessagesPanelContentContainer';

const useStyles = buildUseStyles('MobileMessagesPanel', (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    flexGrow: 1,
  },
  drawerHeader: {
    display: 'flex',
    justifyContent: 'flex-start',
    margin: theme.spacing(1),
  },
  drawerPaper: {
    width: '100%',
  },
}));

const MobileMessagesPanel = ({
  className,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { selectedThreadResource } = useMessagesContext();

  return (
    <Drawer
      className={classNames(classes.root, className)}
      variant="temporary"
      anchor={'right'}
      open={selectedThreadResource}
      classes={{
        paper: classes.drawerPaper,
      }}
      ModalProps={{
        keepMounted: true, // Better open performance on mobile.
      }}
    >
      <MessagesPanelContentContainer />
    </Drawer>
  );
};

MobileMessagesPanel.defaultProps = {
  className: '',
};

MobileMessagesPanel.propTypes = {
  className: PropTypes.string,
};

export { MobileMessagesPanel };
